import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { G1N5Form } from 'features/kestrelViewer/ui/G1N5Form'
import { HelperText } from 'features/kestrelViewer/ui/HelperText'
import { MarkupPopupMenu } from 'features/kestrelViewer/ui/popupMenu/MarkupPopupMenu'
import { Settings } from 'features/kestrelViewer/ui/Settings'
import { KestrelViewerTools } from 'features/kestrelViewer/ui/tools/KestrelViewerTools'
import { PlaneControls } from 'features/kestrelViewer/ui/tools/PlaneControls'
import React from 'react'

export const KestrelViewerUI: React.FC = () => {
  const { selectedMarkup, is2DPlaneModeActive, g1n5FormOpen } =
    useKestrelViewerContext()

  return (
    <>
      <KestrelViewerTools />
      <HelperText />
      <Settings />
      {!!selectedMarkup && <MarkupPopupMenu />}
      {is2DPlaneModeActive && <PlaneControls />}
      {g1n5FormOpen && <G1N5Form />}
    </>
  )
}
